export const INPUT_ERRORS = {
  required: "Este campo es requerido",
  email: "Formato de correo electronico incorrecto",
  negative_number: "El número debe ser positivo",
  password: "La contraseña debe contener al menos una letra y un número.",
};
